// extracted by mini-css-extract-plugin
module.exports = {"header_title":"styles_header_title__bjOYI","testimonials":"styles_testimonials__AF2ho"};